module.exports = __webpack_public_path__ + "img/feature-push-notification-history.7c2329d7.png";